import { ErrorMessage, Form, Formik } from 'formik'
import { Calendar } from 'primereact/calendar'
import React, { useEffect, useMemo, useState } from 'react'
import { useMap } from 'react-leaflet'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Breadcrumb from 'src/components/Common/Breadcrumb'
import InputCom from 'src/components/Common/Input'
import Button from 'src/components/UI/Button'
import DropdownInput from 'src/components/UI/DropdownInput'
import ErrorText from 'src/components/UI/ErrorText'
import { ROUTER } from 'src/constants/routes'
import { formatDateTOYYYYMMDD } from 'src/helpers/common_helpers'
import { clearNotificationConfig, getNotificationConfig, postNotificationConfig } from 'src/store/notification/action'
import { RootReducerState } from 'src/store/reducers'
import * as Yup from 'yup';
import { useToast } from "src/components/Common/ReactToaster";
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup'

const NotificationConfig = () => {

  const { notificationConfig ,error, message , loading } = useSelector((state: RootReducerState) => state.NotificationReducer);
    const dispatch = useDispatch()
    const [visible, setVisible] = useState(false);
    const { showToast } = useToast();
    
    const handleSubmit = (values:any)=>{
        dispatch(postNotificationConfig(values))
    }
    
    const initialvalue = useMemo(()=>{
        return{
            fromDate:notificationConfig?.fromDate ? formatDateTOYYYYMMDD(notificationConfig?.fromDate) : "",
            toDate:notificationConfig?.toDate ? formatDateTOYYYYMMDD(notificationConfig?.toDate) : ""
        }
    },[notificationConfig])

    const validationSchema = Yup.object().shape({
      fromDate: Yup.string().required('From Date is required'),
      toDate: Yup.string()
        .required('To Date is required')
        .test(
        'is-greater-than-from-date',
        'To Date must be greater than From Date',
        function (toDate) {
            const { fromDate } = this.parent;
            if (!fromDate || !toDate) return true;
            return new Date(toDate) > new Date(fromDate);
        }),
    })

  const handleReset = (resetForm: any) => {
    resetForm()
  }

  useEffect(() => {
    if (error) {
      setVisible(true)
    }
    if (message !== "" ) {
      showToast(message, { type: "success" });
        setTimeout(()=>{
            dispatch(clearNotificationConfig())
            dispatch(getNotificationConfig())
        },1000)
    
    }
  }, [error, message])

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }

  }, [loading]);

  
    const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    )
  }

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearNotificationConfig())
  }
  useEffect(()=>{
    dispatch(getNotificationConfig())
    return()=>{
        dispatch(clearNotificationConfig())
    }
  },[])

  return (
    <div>
          <div className="page-content" id="view-brand">
            {visible && dialogContainer(error)}
        <Container fluid>
            <h5>Notification Time Config</h5>
          <Row>
            <Col lg={3}>
            <Card>
              <CardBody>
                <React.Fragment>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialvalue}
                    validationSchema={validationSchema}
                    enableReinitialize>
                    {({ values, handleChange, touched, errors, handleBlur, resetForm, reset, ...rest }: any) => {
                      return (
                        <Form onChange={handleChange}>
                          <Row>

                            <Col lg={12} className='mb-2'>
                              <InputCom
                                    labelName="From Date"
                                    inputclassName="form-control"
                                    labelClassName="form-Label"
                                    type="date"
                                    name="fromDate"
                                    onBlur={handleBlur}
                                    value={values.fromDate}
                                    onChange={handleChange}
                                    isRequired={true}
                                    invalid={
                                    touched["fromDate"] && errors["fromDate"]
                                        ? true
                                        : false
                                    }
                                />
                            </Col>
                            <Col lg={12} >
                            <InputCom
                                    labelName="To Date"
                                    inputclassName="form-control"
                                    labelClassName="form-Label"
                                    type="date"
                                    name="toDate"
                                    onBlur={handleBlur}
                                    value={values.toDate}
                                    onChange={handleChange}
                                    isRequired={true}
                                    invalid={
                                    touched["toDate"] && errors["toDate"]
                                        ? true
                                        : false
                                    }
                                />
                            </Col>
                     
                            <div className="d-flex justify-content-end mt-2">
                              <Button
                                className="secondary-btn me-2"
                                label={"Reset"}
                                type="button"
                                onClick={() => handleReset(resetForm)}
                              />
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label={"Update"}
                                type="submit"
                              />
                            </div>

                          </Row>


                        </Form>
                      )
                    }}
                  </Formik>
                </React.Fragment>
              </CardBody>
            </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default NotificationConfig